// extracted by mini-css-extract-plugin
export default {"Link":"FnUseZBk"};